import { Step } from 'react-joyride';

export const teamsTourSteps: Step[] = [
  {
    target: '[data-tour="teams-header"]',
    content: (
      <div>
        <h4>Teams Management</h4>
        <p>
          Organize your agents into teams for better workflow management, call routing, and
          performance tracking.
        </p>
      </div>
    ),
    placement: 'bottom',
    disableBeacon: true
  },
  {
    target: '[data-tour="create-team-button"]',
    content: (
      <div>
        <h4>Create New Team</h4>
        <p>
          Click here to create a new team. Give it a name and description, then assign agents to
          the team.
        </p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="search-teams"]',
    content: (
      <div>
        <h4>Search Teams</h4>
        <p>Quickly find specific teams by name or description.</p>
      </div>
    ),
    placement: 'bottom'
  },
  {
    target: '[data-tour="teams-table"]',
    content: (
      <div>
        <h4>Teams List</h4>
        <p>
          View all your teams with member counts and status. Click on any team to view members and
          edit team details.
        </p>
      </div>
    ),
    placement: 'top'
  },
  {
    target: '[data-tour="team-actions"]',
    content: (
      <div>
        <h4>Team Actions</h4>
        <p>
          Edit team information, manage team members, or delete teams. You can also view team
          performance metrics here.
        </p>
      </div>
    ),
    placement: 'left'
  }
];
